<template>
  <div class="Persibox">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        管理员列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div @click="gett()" style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div class="filtrate" v-if="role">
      <div class="filtrate_head">
        <div class="filtrate_filer">筛选查询</div>
        <div class="filtrate_seek">
          <strong>用户名搜索:</strong>
          <el-input
            size="small"
            v-model="input"
            clearable
            placeholder="请输入用户姓名"
            style="width:194px"
          ></el-input>
          <strong>所属部门:</strong>
          <el-select clearable v-model="value" size="small" :data="options" placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <div class="filtrate_seek_sousuo" @click="search()">搜索</div>
        </div>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <router-link to="./add_admin" tag="div" class="center_list_head_rig">添加管理员</router-link>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="username" label="成员账号" align="center"></el-table-column>

        <el-table-column prop="real_name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
        <el-table-column prop="name" label="所属部门" align="center"></el-table-column>
        <el-table-column prop="create_date" label="添加时间" width="100" align="center"></el-table-column>
        <el-table-column prop="last_login_date" label="上次登录" width="100" align="center"></el-table-column>
        <el-table-column prop="forbidden" label="禁用/激活" width="90" align="center">
          <template slot-scope="scope">
            <el-switch
              @change="status($event,scope.row.id)"
              v-model="scope.row.status"
              active-color="rgb(19, 206, 102)"
              inactive-color="#dcdfe6"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="139" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <router-link
              target="_blank"
              :to="'./allocationClient/'+ scope.row.id"
            >
              <button @click="allocation(scope.row.id)">分配客户</button>
            </router-link>

            <button @click="red(scope.row.id)">编辑</button>
            <button @click="del(scope.row.id)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col style="margin:0 auto">
            <el-pagination
              style="text-align:center"
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: 'leftmenu',
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      topic: [],
      brand: [],
      str: 'test',
      username: '',
      token: '',
      router: '',
      menuItems: null,
      style1: {
        height: null
      },
      total: 0,
      current_page: null,
      input: '',
      value: '',
      options: [],
      tableData: [],
      group_id: 0,
      page: null
    }
  },
  created() {
    this.$store.state.leftTitle = '管理员列表'
    this.$store.state.topActiveId = 6
    this.gett()
    this.get_group()
  },
  watch: {
    $route: {
      handler(to) {
        const tab = to.params.tab
        this.router = this.$route.name.name
      }
    }
  },
  methods: {
    red(id) {
      //跳转编辑
      this.$router.push({
        path: '/admin/redactPmision/' + id
      })
    },
    setPage(v) {
      //分页
      this.page = v
      this.gett(v)
      this.selectAll = false
    },
    //获取所属部门属性
    get_group() {
      const that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      if (this.token === this.token) {
        this.axios
          .get(this.serve+'/admin/get_admin_group', {
            params: {
              username: this.username,
              token: this.token
            }
          })
          .then(res => {
            that.options = res.data.data
          })
      }
    },
    search() {
      //搜索
      this.tableData = []
      const that = this

      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      if (this.token === this.token) {
        this.axios
          .get(this.serve+'/admin/get_user_list', {
            params: {
              username: this.username,
              token: this.token,
              real_name: this.input,
              group: this.value
            }
          })
          .then(res => {
            var json = res.data
            if (json.status == 'success') {
              that.current_page = res.data.data.now_page
              that.total = res.data.data.page_num
              for (var key in json.data) {
                if (key >= 0) {
                  that.tableData.push(json.data[key])
                }
              }
            } else {
              this.tableData = []
              this.total = 0
              this.now_page = 1
            }
          })
      }
    },
    gett(page) {
      //获取数据
      const that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      if (this.token === this.token) {
        this.axios
          .get(this.serve+'/admin/get_user_list', {
            params: {
              page: page,
              username: this.username,
              token: this.token
            }
          })
          .then(res => {
            this.tableData = []
            var json = res.data.data
            if (res.data.status === 'success') {
              that.current_page = json.now_page
              that.page = json.now_page
              that.total = json.page_num
              for (var key in json) {
                if (key >= 0) {
                  that.tableData.push(json[key])
                }
              }
            }else{
              if(res.data.msg == "无权访问"){
                this.role = false
              }
            }
          })
      }
    },

    status(v, id) {
      //禁用激活
      const that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      this.axios
        .get(this.serve+'/admin/status_admin_user', {
          params: {
            username: this.username,
            token: this.token,
            id: id
          }
        })

        .then(res => {
          if (res.data.status == 'success') {
            if (v == 1) {
              var str = '激活'
            } else {
              var str = '禁用'
            }
            this.$notify({
              title: str + '成功',
              message: '管理员' + str + '成功',
              type: 'success'
            })
          }
        })
    },
    del(id) {
      //删除按钮
      var that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      if (this.token === this.token) {
        this.$confirm('删除后不能恢复, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.axios
              .get(this.serve+'/admin/del_admin_user', {
                params: {
                  id: id,
                  username: this.username,
                  token: this.token
                }
              })
              .then(function(res) {
                if (res.data.status == 'success') {
                  that.$message({
                    type: 'success',
                    message: '删除成功!'
                  })

                  that.gett(that.page)
                  // that.group(options)
                }else if(res.data.code == '403'){
                  that.$message.error(res.data.msg); 
                } else {
                  that.$message({
                    type: 'error',
                    message: '删除失败!'
                  })
                }
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      }
    }
  }
}
</script>

<style lang="scss">
.Persibox {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
}
.el-pagination {
  text-align: center;
}

.topBar {
  margin-bottom: 40px;
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}

.filtrate {
  width: 1060px;
  height: 100%;
  // margin-left: 420px;
  // background: orange;
  margin: 0 auto;
  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1044px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: 'MicrosoftYaHei';
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: 'MicrosoftYaHei';
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: 'MicrosoftYaHeiLight';
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }

    .el-input__icon {
      line-height: 28px;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}
button {
  // border: 0;
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  font-family: 'MicrosoftYaHeiLight';
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
  cursor: pointer;
}
button:hover {
  color: #0099ff;
}
.el-row {
  display: flex;
  justify-content: center;
}
.cell {
  color: #606266 !important;
}
</style>

